import { Pipe, PipeTransform } from '@angular/core';
import { ItemSelectorRowItem } from '../interface';

@Pipe({
  name: 'isItemDisabled',
  pure: false,
  standalone: false,
})
export class IsItemDisabledPipe implements PipeTransform {
  transform(item: ItemSelectorRowItem, hideQuantity: boolean): boolean {
    if (item.isSuspended || item.unavailableInCountry) return true;
    if (item.isMultiactivatable && !hideQuantity) return false;

    const invalidEditions = item?.usesEditions && !item?.editions;
    return item?.immutable || !!invalidEditions;
  }
}
